import {TextField as MUITextField}  from '@mui/material';
import { Controller } from "react-hook-form";


const TextField = ({field,useFormRef,schema,...props}) => {
  const {control} = useFormRef;

  const errorMessage = (error) => {
    if(error) {
      if(Array.isArray(error)) {
        return error
          .filter(({message})=>message)
          .map(({message})=>message)
          .join(', ');
      }
      else
        return error.message;
    }
    return '';
  };

  return (
    <Controller
      name={field}
      control={control}
      render={({
        field,
        fieldState: { invalid, isTouched, isDirty, error }
      }) => (
        <MUITextField
          label={schema?.fields[field.name].spec.label}
          required={schema?.fields[field.name].exclusiveTests['required']}
          error={error!=null}
          helperText={errorMessage(error)}
          {...field}
          value={field.value?field.value:''}
          {...props} />)}
      defaultValue=''
    />

  );
};

export default TextField;
